import { EmissionsHomePage } from "#src/batteries-included-components/Layouts/HomeEmissions";
import React from "react";

export const HomePage = () => <EmissionsHomePage />;
